import React from 'react';

function WCLogoTransparentW() {
  return (
    <svg width="130" height="130" viewBox="0 0 130 130" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M65 0C29.0924 0 0 29.0924 0 65C0 100.908 29.0924 130 65 130C100.908 130 130 100.908 130 65C130 29.0924 100.908 0 65 0ZM52.5911 96.1932L26.9917 45.0921L34.0023 41.5257L59.6016 92.6268L52.5911 96.1932ZM82.5629 95.6313L56.9635 44.5302L63.51 41.2082L89.1094 92.3093L82.5629 95.6313ZM95.1184 58.1849L87.717 45.1165L94.2879 41.77L101.689 54.8384L95.1184 58.1849Z" fill="white"/>
    </svg>
  );
}

export default WCLogoTransparentW;
